import React from 'react';

type AdminPageDeleteConfigModalProps = {
  userName: string;
  onClose: () => void;
  onConfirm: () => void;
  loading: boolean;
};

const AdminPageDeleteConfigModal: React.FC<AdminPageDeleteConfigModalProps> = ({
  userName,
  onClose,
  onConfirm,
  loading,
}) => (
  <div className="admin-page-modal-overlay">
    <div className="admin-page-modal">
      <div className="admin-page-modal-header">
        <div>
          <h3 className="admin-page-modal-title">Delete Configuration</h3>
          <p className="admin-page-modal-subtitle mt-1">This will remove the assistant configuration for this user.</p>
        </div>
        <button
          type="button"
          onClick={onClose}
          className="admin-page-modal-close"
          aria-label="Close modal"
          disabled={loading}
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <div className="admin-page-modal-body space-y-4">
        <div className="admin-page-modal-user-box">
          <p className="admin-page-modal-label">User</p>
          <p className="admin-page-modal-user-name">{userName}</p>
        </div>

        <div className="admin-page-warning-yellow">
          <p className="admin-page-warning-title">⚠️ Warning</p>
          <p className="admin-page-warning-text">This will remove:</p>
          <ul className="admin-page-warning-list">
            <li>Outbound Assistant ID</li>
            <li>Inbound Assistant ID</li>
            <li>Phone Number ID</li>
          </ul>
          <p className="admin-page-warning-footer">The user will need to reconfigure these settings to make calls.</p>
        </div>
      </div>

      <div className="admin-page-modal-actions">
        <button type="button" onClick={onClose} className="admin-page-modal-btn admin-page-modal-btn-cancel" disabled={loading}>
          Cancel
        </button>
        <button
          type="button"
          onClick={onConfirm}
          disabled={loading}
          className={`admin-page-modal-btn admin-page-modal-btn-confirm ${loading ? 'admin-page-modal-btn-disabled' : 'admin-page-modal-btn-danger'}`}
        >
          {loading ? (
            <>
              <span className="admin-page-modal-spinner" />
              Deleting…
            </>
          ) : (
            'Delete Configuration'
          )}
        </button>
      </div>
    </div>
  </div>
);

export default AdminPageDeleteConfigModal;
